import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f59563ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row text-center justify-content-between" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col mt-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col mt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-auto" }, null, -1))
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row mt-2" }
const _hoisted_12 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.slice(0, _ctx.displayedSlice), (entry, i) => {
        return (_openBlock(), _createBlock(_component_Card, {
          key: i,
          class: "col-md-3 my-2 card-border card-center",
          height: '312px',
          "max-width": '256px',
          outlined: _ctx.outlineMyItems,
          "with-shadow": true,
          onClick: ($event: any) => (_ctx.routeToIndividualPage(entry))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  class: "feature-img",
                  src: entry?.featureImage?.url
                }, null, 8, _hoisted_5)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h5", null, _toDisplayString(entry.title), 1)
              ])
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.topic, (topic, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: i,
                    class: "tag-font"
                  }, _toDisplayString(topic.split("_").join(" ")) + _toDisplayString(entry.topic[i + 1] ? ", " : " "), 1))
                }), 128))
              ])
            ])
          ]),
          _: 2
        }, 1032, ["outlined", "onClick"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (!_ctx.hideLoadMoreBtnWhenBtnIsDisabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "secondary-button-hover",
              text: 'Load More',
              disabled: _ctx.disableLoadMoreButton,
              onButtonClick: _ctx.loadMore
            }, null, 8, ["disabled", "onButtonClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}